import { createSlice } from "@reduxjs/toolkit";

const accountGroupSlice = createSlice({
    name:'accountgroup',
    initialState:{
        accountgroup:[]
    },
    reducers: {
        addAccountGroup : (state,action) => {
            state.accountgroup = [...state.accountgroup,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addAccountGroup } = accountGroupSlice.actions;
export default accountGroupSlice.reducer;